import { ToggleGroup, ToggleGroupItem } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import { useScheduleMode } from '@/hooks/use-schedule-mode';
import { useSchedulePage } from '@/hooks/use-schedule-page';
import { SCHEDULE_MODES } from '@/utils/date-ranges';

export const ModeToggle = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useScheduleMode();
  const [, setPage] = useSchedulePage();

  const handleValueChange = (values: unknown[]) => {
    const next = SCHEDULE_MODES.find((option) => values.includes(option));
    if (next && next !== mode) {
      setMode(next);
      void setPage(null);
    }
  };

  return (
    <ToggleGroup
      aria-label={t(($) => $.view)}
      variant="outline"
      size="sm"
      spacing={0}
      value={[mode]}
      onValueChange={handleValueChange}
    >
      <ToggleGroupItem value="week">{t(($) => $.weekly)}</ToggleGroupItem>
      <ToggleGroupItem value="month">{t(($) => $.monthly)}</ToggleGroupItem>
      <ToggleGroupItem value="year">{t(($) => $.yearly)}</ToggleGroupItem>
    </ToggleGroup>
  );
};
